<!-- components/NotificationsPage.vue -->
<template>
    <div class="bg-[var(--background-primary)] border border-[var(--background-btn)] rounded-2xl p-4">
        <div class="max-w-[380px] mx-auto ">
            <h1 class="text-[#ffffff] text-xl font-semibold mb-4">Notifications</h1>

            <!-- Stacked notification cards -->
            <div class="relative">
                <!-- Background cards for stacking effect -->
                <div class="absolute top-2 left-2 right-2 h-32 bg-gray-700/30 rounded-2xl"></div>
                <div class="absolute top-4 left-4 right-4 h-32 bg-gray-600/40 rounded-2xl"></div>

                <!-- Main notification card -->
                <div class="relative bg-gray-700 rounded-2xl p-4 flex items-start gap-6">
                    <!-- Shopping cart icon -->
                    <div
                        class="flex-shrink-0 w-16 h-16 bg-gray-600 rounded-full flex items-center justify-center text-white text-xl">
                        <i class="pi pi-shopping-cart"></i>
                    </div>

                    <!-- Notification content -->
                    <div class="flex-1">
                        <h2 class="text-[#ffffff] text-lg font-semibold mb-2 text-balance">
                            Don't miss out on your tools!
                        </h2>
                        <p class="text-gray-300 text-xs leading-relaxed">
                            We noticed you left some great items in your cart. Complete your purchase now and get back
                            to work with the tools you need. Stocks may not last, so don't wait too long!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
// No additional imports needed for PrimeVue icons if you have PrimeIcons installed
</script>
